// SessionCard.js
import React from "react";

const SessionCard = ({ sessionData }) => {
  return (
    <div className=" bg-blue-200 p-5 rounded-md">
      <div className="w-full flex justify-between items-start">
        <div className="problemsolver md:flex justify-center items-center">
          <img
            src={sessionData.profileImage}
            alt="Profile"
            className="w-14 h-14 rounded-full mr-3"
          />
          <div className="">
            <h1 className="text-2xl">{sessionData.name}</h1>
            <span className="bg-blue-100 px-2 py-1 rounded mt-2">
              {sessionData.topic}
            </span>
          </div>
        </div>

        <p className="text-right">{sessionData.date}</p>
      </div>

      <hr className="my-4" />
      <div className="flex items-center">
        <div className="flex-1">
          <div className="bg-gray-100 p-4 rounded-md">
            {sessionData.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionCard;
